import { useQuery } from '@tanstack/react-query';
import { fetchClient } from '@nike/fetch-client';
import makeQueryKey from '../../utils/make-query-key';

/**
 * Fetches static data from cart static dada S3 bucket
 * @param {Object} params
 * @param {String} params.resource - the resource to fetch
 * @param {String} params.file - the file to fetch
 * @param {Boolean} params.enabled - whether the query should be enabled. Enabled based on tooltip specific feature flag.
 * @returns {Object} - the query object
 */

var useFetchStaticData = function useFetchStaticData(_ref) {
  var resource = _ref.resource,
    file = _ref.file,
    enabled = _ref.enabled,
    resourcePath = _ref.resourcePath;
  return useQuery({
    queryKey: makeQueryKey([resource, file, resourcePath]),
    queryFn: function queryFn() {
      return fetchClient("https://".concat(process.env.NEXT_PUBLIC_HOST_NAME, "/assets/").concat(resourcePath, "/").concat(resource, "/").concat(file, ".json"));
    },
    staleTime: Infinity,
    enabled: !!enabled && !!resourcePath && !!resource && !!file
  });
};
export default useFetchStaticData;